module.exports = __webpack_public_path__ + "static/media/fremod001.cef6c4b9.png";